import { API_ERROR, ERROR_CODE, ERRORPOPUP_NAVIGATION_TO_BACK } from '../../constants';
const initialState = {
    errorCode: undefined,
    errorResponse: undefined,
    isPreStoreFromGoBack: false,
};
const errorReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ERROR_CODE:
            return {
                ...state,
                errorCode: action.errorCode,
                errorResponse: undefined,
            };
        case API_ERROR:
            return {
                ...state,
                errorResponse: action.payload,
            };
        case ERRORPOPUP_NAVIGATION_TO_BACK:
            const { isFromGoBack } = action;
            return {
                ...state,
                isPreStoreFromGoBack: isFromGoBack,
            };
        default:
            return state;
    }
};
export default errorReducer;
